import { Container } from '@/components/Container';
import { Button } from '@/components/Button';
import { Callout } from '@/components/Callout';
import { Card, CARD_TITLE } from '@/components/Card';
import { DraftMarker } from '@/components/DraftMarker';
import { PageHeader } from '@/components/PageHeader';
import { PORTAL_URL } from '@/config';
import { SITE } from '@/data/site';
import { photos } from '@/data/images';

export function Contact() {
  return (
    <>
      <PageHeader
        title="Contact"
        intro="The ITES office is at Station Plaza, close to Bhandup station in Mumbai."
        image={photos.contact}
        objectPosition="center 62%"
      />
      <Container className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,400px),1fr))] items-start gap-8 pt-[clamp(32px,5vw,56px)] pb-[clamp(56px,7vw,96px)]">
        <Card as="section" aria-labelledby="h-office">
          <h2 id="h-office" className={CARD_TITLE}>ITES office</h2>
          <address className="m-0 text-[1.1875rem] leading-[1.6] text-ink not-italic">
            {SITE.addressLines.map((line, i) => (
              <span key={line}>
                {i > 0 && <br />}
                {line}
              </span>
            ))}
          </address>
          <dl className="m-0 mt-6 grid grid-cols-[auto_1fr] gap-x-5 gap-y-3 text-[1.125rem]">
            <dt className="text-muted">Telephone</dt>
            <dd className="m-0"><a href={SITE.phoneHref} className="font-semibold text-ink underline">{SITE.phone}</a></dd>
            <dt className="text-muted">Mobile</dt>
            <dd className="m-0"><a href={SITE.mobileHref} className="font-semibold text-ink underline">{SITE.mobile}</a></dd>
            <dt className="text-muted">Email</dt>
            <dd className="m-0 min-w-0 [overflow-wrap:anywhere]">
              <a href={SITE.emailHref} className="font-semibold text-ink underline">{SITE.email}</a>
              <DraftMarker className="mt-1.5 block text-[0.75rem]">VERIFY · the E-Journal prints itesmumbai@yahoo.com</DraftMarker>
            </dd>
          </dl>
          <Button href={SITE.mapsUrl} className="mt-7">Open in Maps →</Button>
        </Card>
        <Callout aria-labelledby="h-portal" className="p-[clamp(24px,4vw,36px)]">
          <p className="m-0 mb-2.5 font-mono text-[0.75rem] tracking-[0.08em] text-teal-700 uppercase">Authorised users</p>
          <h2 id="h-portal" className="m-0 font-serif text-h3 font-semibold text-navy-900">Staff &amp; institute portal</h2>
          <p className="mt-3 mb-0 text-[1.0625rem] leading-[1.6] text-ink-2">
            ITES staff and affiliated institutes sign in to the portal. The portal is separate from this public site.
          </p>
          <Button href={PORTAL_URL} className="mt-[22px]">Go to portal login →</Button>
        </Callout>
      </Container>
    </>
  );
}
